import * as Scrivito from "scrivito"

export const ProjectsKpiWidget = Scrivito.provideWidgetClass(
  "ProjectsKpiWidget",
  {
    attributes: {
      content: "widgetlist"
    }
  }
)
